module.exports = __webpack_public_path__ + "img/clipboard.6c62ac63.png";